<template>
    <v-dialog
        v-model="show"
        :title="title"
        kind="modal"
        :status="status"
        :footer-config="footerConfig"
        class="user-bind-tel-dialog modify-tel-dialog"
        :class="{'user-bind-tel-tip': step !== 0 && step !== 3}"
        @confirm="formSubmit"
        @cancel="close"
        @close="close"
    >
        <v-steps v-if="!toLoginAccount && step === 0" :index="stepIndex" :titles="titles" />
        <div
            v-if="showTitle"
            class="modify-tel-desc"
        >
            <div v-if="!toLoginAccount">
                <div v-if="!verPreMobSuc">
                    {{ $t('为了企点账号安全，请先输入手机验证码进行验证') }} <br>
                    <i18n-t path="若手机号无法使用，请点击{apply}以修改联系手机" tag="span">
                        <a slot="apply" @click="submitApplication">{{ $t('提交申请表') }}</a>
                    </i18n-t>
                    </div>
                <div v-else>
                {{ $t('修改后，新手机号可登录账户中心进行管理操作，并接收重要的验证信息，建议使用企业主或企业管理员的手机号') }}
                </div>
            </div>
            <div v-else>
                {{ $t('用于登录账户中心进行管理操作，并接收重要的验证信息，建议使用企业主或企业管理员的手机号') }}
            </div>
        </div>
        <div class="body">
            <v-form
                v-if="step === 0"
                ref="telForm"
                class="form"
                kind="desc"
                @submit.prevent="confirm"
            >
                <v-form-item
                    :rules="isChangeTel && !verPreMobSuc ? [] : formRules.mobile"
                    name="mobile"
                    error-placement="bottom-left"
                    :label="$t('手机号')"
                    :required="$t('请输入手机号')"
                >
                    <v-input
                        ref="internationalTelInput"
                        v-model="form.mobile"
                        :width="354"
                        :disabled="!verPreMobSuc || toLoginAccount"
                        :clearable="false"
                        class="default-input-tel"
                        :placeholder="$t('请输入手机号')"
                        autofocus
                    />
                </v-form-item>
                <v-form-item
                    :rules="formRules.sms_code"
                    name="sms_code"
                    error-placement="bottom-left"
                    :label="$t('验证码')"
                    :required="$t('请输入验证码')"
                    class="input_sms_code-form"
                >
                    <div
                        class="input_sms_code"
                    >
                        <v-input
                            v-model="form.sms_code"
                            :width="244"
                            name="sms_code"
                            :placeholder="$t('请输入验证码')"
                        />
                    <v-button
                        :disabled="isCountdown || !form.mobile"
                        class="captch-btn"
                        @click="sendCaptcha"
                    >
                        {{ isCountdown ? $t('{n}s', { n: countdown }) : $t('获取验证码') }}
                    </v-button>
                    </div>
                </v-form-item>
            </v-form>
            <div
                v-show="step === 1"
                class="tip-box"
            >
                <div class="tip-box-description">
                    <div>
                        <v-icon name="basic_tips_fill" remote size="60" class="icon-warning" flip="vertical" />
                    </div>
                    <span class="tip-box-description-text">
                        {{ $t('升级失败，该手机号已被占用，请更换手机号重试') }}
                    </span>
                </div>
            </div>
            <div
                v-show="step === 2"
                class="tip-box"
            >
                <div class="tip-box-description">
                    <div>
                        <v-icon name="basic_tips_fill" remote size="60" class="icon-warning" flip="vertical" />
                    </div>
                    <span class="tip-box-description-text">
                        {{ $t('该手机号绑定的管理员账号已达上限，请更换手机号重试') }}
                    </span>
                </div>
            </div>
            <div
                v-show="step === 3"
                class="tip-box"
            >
                <div class="tip-box-description">
                    <div>
                        <v-icon name="basic_tips_fill" fill="red" remote size="60" class="icon-primary" />
                    </div>
                    <span class="tip-box-description-text">
                        {{ $t('该手机号绑定过') }}
                        <span
                            v-for="(item, index) in showAidList"
                            :key="index"
                        >
                            <span>{{ item.corp_short_name }}<span v-if="index !== showAidList.length - 1">{{ $t('、') }}</span>
                            </span>
                        </span>
                        {{ $t('的管理员，是否继续绑定') }}
                    </span>
                </div>
            </div>
            <div
                v-show="step === 5"
                class="tip-box"
            >
                <div class="tip-box-description">
                    <div>
                        <v-icon name="basic_finish_fill" fill="red" remote size="60" class="icon-success" />
                    </div>
                    <p class="tip-box-description-text">
                        {{ $t('绑定成功') }}
                    </p>
                </div>
                <v-footer-actionbar size="large"
                :divider="false"
                :layout="{
                    cancel: {
                        text: $t('知道了')
                    }
                }"
                @cancel="close"
/>
            </div>
        </div>
    </v-dialog>
</template>

<script>
const CHECK_MSG_URL = '/mng/account/contacts/checkVerifySMS'; // 验证码校验
const GET_AID_URL = '/v1/basic.account.account_web.Account/AidByPhoneV2'; // 获取已绑定账号
const UPDATE_ADMIN_TEL = '/mng/account/contacts/updateContactMobile'; // 换绑手机
const GET_CAPTCHA = '/mng/account/contacts/sendVerifySMS'; // 发送验证码
const GET_CAPTCHA_LOGIN = '/v1/basic.account.account_web.AccountWeb/SendLoginMSG'; // 升级至登录发送验证码
const UPGRADE_LOGIN = '/v1/basic/corp/corp/upgradeToLoginMobile'; // 升级至登录手机号
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
};
const COUNT_DOWN_INIT = 60;
export default {
    props: {
        isChangeTel: {
            type: Boolean,
            default: true,
        },
        showDialog: {
            type: Boolean,
            default: false,
        },
        mobile: {
            type: String,
            default: '',
        },
        toLoginAccount: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            titles: [this.$t('账号验证'), this.$t('修改手机号')],
            show: false,
            aidList: [],
            filterAidList: [],
            form: {
                ...DEFAULT_FORM,
                mobile: this.mobile,
            },
            step: 0,
            countdown: COUNT_DOWN_INIT,
            countdownTimer: null,
            verPreMobSuc: false,
            oldCode: '',
            oldMobile: '',
            formRules: {
                mobile: [
                    {
                        require: true,
                        message: this.$t('手机号不能为空'),
                        trigger: 'submit',
                    },
                    {
                        validate(value) {
                            return /^1(?:\d){10}$/.test(value);
                        },
                        message: this.$t('手机号格式不正确'),
                        trigger: 'change',
                    },
                    {
                        validate(value) {
                            return /^1(?:\d){10}$/.test(value);
                        },
                        message: this.$t('手机号格式不正确'),
                        trigger: 'submit',
                    },
                ],
                sms_code: [
                    {
                        required: true,
                        message: this.$t('验证码不能为空'),
                        trigger: 'submit',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: this.$t('验证码格式错误'),
                        trigger: 'submit',
                    },
                ],
            },
            stepIndex: 1,
        };
    },
    computed: {
        showAidList() {
            const len = this.filterAidList.length;
            if (len > 1) {
                return [
                    this.filterAidList[0],
                    this.filterAidList[1],
                ];
            } if (len === 1) {
                return [
                    this.filterAidList[0],
                ];
            }
            return [];
        },
        showTitle() {
            return this.step === 0;
        },
        isCountdown() {
            return this.countdown < COUNT_DOWN_INIT;
        },
        title() {
            if (this.step === 0) {
                return this.toLoginAccount ? this.$t('升级为登录手机号') : this.$t('修改手机号');
            }
            return '';
        },
        footerConfig() {
            return {
                primary: {
                    kind: this.confirmKind,
                    text: this.confirmText,
                },
                cancel: {
                    kind: 'default',
                    text: this.$t('取消'),
                },
            };
        },
        confirmKind() {
            if (this.step === 1 || this.step === 2) {
                return 'warning';
            }
            return 'primary';
        },
        confirmText() {
            if (this.step === 0) {
                return this.stepIndex === 1 && !this.toLoginAccount ? this.$t('下一步') : this.$t('确认');
            } if (this.step === 1 || this.step === 2) {
                    return this.$t('重新输入手机号');
            } if (this.step === 3) {
                return this.$t('继续绑定');
            }
                return '';
        },
        status() {
            if (this.step === 5) {
                return 'default';
            }
            return '';
        },
    },
    watch: {
        showDialog: {
            handler(newVal) {
                this.resetForm();
                this.$set(this.form, 'mobile', this.mobile);
                this.show = newVal;
                this.step = 0;
                this.stepIndex = 1;
                this.verPreMobSuc = false;
            },
            deep: true,
        },
    },
    methods: {
        submitApplication() {
            this.close();
            this.$emit('openApplication', 0);
        },
        close() {
            this.$emit('close');
        },
        handleFormSubmit() {
            const form = {
                newMobilePhoneNum: this.form.mobile,
                oldMobilePhoneNum: this.oldMobile,
                oldPhoneSMSCode: this.oldCode,
                newPhoneSMSCode: this.form.sms_code,
            };
            if (this.form.mobile === this.oldMobile) {
                this.$message.error(this.$t('新手机号不能与原手机号相同'));
                return;
            }
            this.$ajax.post(UPDATE_ADMIN_TEL, form)
            .then(() => {
                this.$message.success(this.$t('更换手机成功'));
                this.close();
                this.$emit('on-bind-success');
            });
        },
        startCountdown() {
            this.countdown--;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= -1) {
                    this.clearCountdownTimer();
                    this.countdown = COUNT_DOWN_INIT;
                }
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearCountdownTimer);
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            if (!/^1(?:\d){10}$/.test(this.form.mobile)) {
                return;
            }
            let form;
            if (!this.toLoginAccount) {
                form = {
                    mobilePhoneNum: this.form.mobile,
                };
            } else {
                form = {
                    mobile: this.form.mobile,
                    type: 1,
                };
            }
            this.$ajax[this.toLoginAccount ? 'gatewayPost' : 'post'](!this.toLoginAccount ? GET_CAPTCHA : GET_CAPTCHA_LOGIN, form)
                .then(() => {
                    this.startCountdown();
                });
        },
        confirm() {
            if (this.toLoginAccount) {
                if (this.step === 0) {
                    this.getAidlist();
                } else {
                    this.toBindLoginAccount();
                }
            } else {
                if (this.verPreMobSuc) {
                    this.handleFormSubmit();
                } else {
                    this.checkoutPreMobile();
                }
            }
        },
        formSubmit(e) {
            e.preventDefault();
            if (this.step === 0) {
                this.$refs.telForm.submit();
            } else if (this.step === 3) {
                this.confirm();
            } else {
                this.step = 0;
            }
        },
        checkoutPreMobile() {
            this.$ajax.post(CHECK_MSG_URL, { mobilePhoneNum: this.form.mobile, SMSCode: this.form.sms_code })
            .then(() => {
                this.$message.success(this.$t('手机验证成功'));
                this.verPreMobSuc = true;
                this.oldCode = this.form.sms_code;
                this.oldMobile = this.form.mobile;
                this.resetForm();
                this.$set(this.form, 'mobile', '');
                this.stepIndex = 2;
            });
        },
        getAidlist() {
            this.$ajax.gatewayPost(GET_AID_URL, { phone_number: this.form.mobile, sms_code: this.form.sms_code }).then((res) => {
                this.aidList = (res.data && res.data.aid_corp_info) || [];
                this.aidList = this.aidList.filter(item => item.aidtype);
                if (this.aidList.length) {
                    this.aidList.forEach((item) => {
                        const hasCorp = this.filterAidList.filter(cur => item.corp_id === cur.corp_id);
                        if (!hasCorp.length) {
                            this.filterAidList.push(item);
                        }
                    });
                    this.step = 3;
                } else {
                    this.toBindLoginAccount();
                }
                });
        },
        resetForm() {
            this.form = {
                ...DEFAULT_FORM,
                mobile: this.mobile,
            };
            this.clearCountdownTimer();
            this.countdown = COUNT_DOWN_INIT;
            this.step = 0;
        },
        handleBindCurrentCount() {
            this.handleFormSubmit(false);
        },
        toBindLogin(res) {
            const { code } = res;
            if (code === 200031) {
                this.step = 1;
            } else if (code === 200029) {
                this.step = 2;
            } else {
                this.$message.error(res.message || this.$t('出错了'));
            }
        },
        toBindLoginAccount() {
            this.$ajax.gatewayPost(UPGRADE_LOGIN, {}, { customFn: this.toBindLogin }).then(() => {
                this.step = 5;
                this.$emit('refresh-login-mobile');
            });
        },
    },
};
</script>

<style lang="less">
.modify-tel {

    &-dialog {
        .v-dialog__content {
            width: 520px;
        }
        .default-input-tel {
            text-align: left;
        }
        .tip-box {
            &-description {
                font-size: 16px;
                font-weight: 500;

                &-text {
                    display: inline-block;
                    margin: 20px 0 8px 0;
                }

                .icon {
                    &-warning {
                        fill: #f75559;
                    }

                    &-primary {
                        fill: #4A70ff;
                    }

                    &-success {
                        fill: #0fb87f;
                    }
                }
            }
        }

        .input_sms_code {
            height: 32px;
            width: 354px;
            display: inline-flex;
            flex-direction: row;
            justify-content: space-between;
            text-align: left;
            align-items: baseline;

            &-form {
                .v-description-item--horizontal {
                    align-items: center;
                }
            }
        }

        .captch-btn {
            min-width: 102px;
        }
    }
    &-desc {
        display: inline-block;
        width: 100%;
        margin: 8px 0;
        color: rgba(1, 11, 50, 0.41);
        text-align: left;

        a {
            cursor: pointer;
        }
    }
}
.user-bind-tel-tip {
    .v-dialog__content {
        width: 450px;
    }
}
</style>
